import { render, staticRenderFns } from "./ExpenseCreateEdit.vue?vue&type=template&id=f5ca6d34&scoped=true&"
import script from "./ExpenseCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ExpenseCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseCreateEdit.vue?vue&type=style&index=0&id=f5ca6d34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ca6d34",
  null
  
)

export default component.exports